import { Video } from '@/lib/apiTypes';
import { motion } from 'framer-motion';
import { FC, useEffect, useState } from 'react';

const SingleCalendarSpeciesVideo: FC<{ video: Video }> = ({ video }) => {
	const [isThumbnailLoaded, setIsThumbnailLoaded] = useState(false);

	// Preload thumbnail image
	useEffect(() => {
		const image = new Image();
		image.src = video.thumbnail.data?.attributes.url ?? '';
		image.onload = () => {
			setIsThumbnailLoaded(true);
		};

		return () => {
			image.onload = null;
		};
	}, [video.thumbnail.data?.attributes.url]);

	if (!isThumbnailLoaded) return null;

	return (
		<>
			<motion.img
				src={video.thumbnail.data?.attributes.url}
				alt={`Met video: ${video.thumbnail.data?.attributes.alternativeText ?? ''}`}
				className="absolute inset-0 size-full object-cover"
				animate={{
					opacity: [0, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0],
					transition: {
						repeat: Infinity,
						duration: 20,
					},
				}}
			/>
		</>
	);
};

export default SingleCalendarSpeciesVideo;
